/**
 * View for open a existing voyage, start a new voyage, or re-open voyage.
 */


var VRC = VRC || {};
VRC.VoyageStartView = (function () {
	var _wrapper = '.voyagestart__wrapper';

	var init = function () {
		renderVoyageStart();
	};

	var hide = function () {
		$(_wrapper).hide();
	};

	var renderVoyageStart = function () {
		$('#menu_content').html('');
		VRC.NavigationView.disable();
		var template = WELL.Handlebars.VRC.voyage_start;
		var $wrapper = $(_wrapper);
		$wrapper.html(template({}));
		$wrapper.show();
		attachCheckVoyageEvents();
	};

	var attachCheckVoyageEvents = function () {
		var $btn = $('.voyagestart__check-voyage');
		$btn.unbind('click').click(function () {
			var checking = VRC.VoyageService.check();

			checking.done(function (status, data) {

				if (status === VRC.VoyageService.TYPES.OPEN_VOYAGE) {

					var date = '';
					if (data && data.voyage) {
						date = moment(data.voyage.from_date, g_timeStampFormat).format(g_timeStampFormat);
					}

					VRC.ConfirmationModal.show(
						{
							msg: '<p>An open voyage started ' + date + ' was found and loaded locally.</p> <p>Continue reporting or end this voyage. </p><p>To re-open a closed / rejected voyage, click the list voyages button on the voyage screen.</p>',
							title: 'Open Voyage Found.',
							type: VRC.ConfirmationModal.TYPES.INFO
						});
					VRC.ImportService.importData(data);
					VRC.VoyageState.init();

					hide();
				}
				else if (status === VRC.VoyageService.TYPES.AVAILABLE_VOYAGES) {
					var template = WELL.Handlebars.VRC.voyage_available_voyages;
					$(_wrapper).html(template(data));
					checkStartOrContinueEvents(data);
				}
				else {

					var template = WELL.Handlebars.VRC.voyage_available_voyages;
					$(_wrapper).html(template(data));
					checkStartOrContinueEvents(data);
				}
			})
		});
	};

	var checkStartOrContinueEvents = function (data) {
		$('.voyagestart__start').click(function () {

			VRC.CurrentVoyage.fetchNewVoyage();
		});

		$('.voyagestart__reopen').click(function () {
			VRC.ListVoyagesView.loading();
			VRC.ListVoyagesView.render(data);

		});
	};

	return {
		init: init,
		hide: hide

	}
})();
